import { Component } from '@angular/core';

import { AuthService } from 'base-angular-avla';

@Component({
  selector: 'app-carga-archivo',
  templateUrl: './carga-archivo.component.html',
  styleUrls: ['./carga-archivo.component.css'],
})
export class CargaArchivoComponent {
  constructor(private readonly authService: AuthService) {}

  get isAdminChilePeru(): boolean {
    return this.authService.isAllowedHtmlElement(
      19508,
      'PANEL_BULK_LOAD_STATUS_PERSON'
    );
  }
}
